import {
  Container,
  Content,
  FontAwesomeProIcon,
  Heading,
  Image,
} from '@wienenergiegithub/ui-next';
import styles from './RegulatorInfo.module.scss';
import React from 'react';
import PropTypes from 'prop-types';

const RegulatorInfo = ({ infoBoxes }) => (
  <Container className={styles.container} size="lg">
    {infoBoxes?.map(({ alt, icon, image, text, title }) => (
      <div key={title}>
        {image ? (
          <Image alt={alt} className={styles.image} src={image} />
        ) : (
          <FontAwesomeProIcon
            className={styles.icon}
            icon={icon}
            role="presentation"
            type="regular"
          />
        )}
        <Heading className={styles.title} size="h6">
          {title}
        </Heading>
        <Content noSpacing>{text}</Content>
      </div>
    ))}
  </Container>
);

RegulatorInfo.propTypes = {
  infoBoxes: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
      alt: PropTypes.string,
    }),
  ).isRequired,
};

export { RegulatorInfo };
